import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppError } from "@obg/ngx.core";
import { of } from "rxjs";
import { catchError, filter, map, switchMap, take } from "rxjs/operators";

import { RECOMMENDED_GAMES_ACTION_TYPE, RecommendedGamesAction } from "./recommended-games.action";
import { RecommendedGamesService } from "./recommended-games.service";

@Injectable()
export class RecommendedGamesEffect {
	recommendedGames$ = createEffect(() =>
		this.actions$.pipe(
			ofType(RECOMMENDED_GAMES_ACTION_TYPE.getAll),
			switchMap(() => this.service.getRecommendedGamesCollectionOrder$()),
			filter((recommendedGamesOrder) => recommendedGamesOrder !== null),
			take(1),
			switchMap(() =>
				this.service.getAll().pipe(
					map((response) => this.recommendedGamesAction.getAllSuccess(response)),
					catchError((error: AppError) => of(this.recommendedGamesAction.getAllFail(error)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private recommendedGamesAction: RecommendedGamesAction,
		private service: RecommendedGamesService
	) {}
}
